import React from 'react';
import { Row } from '../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../../components/fields/TextInput/TextInputWithLabel';
import VisitDTO from '../../../../dto/VisitsDTO';
import DateTimePicker from '../../../../components/fields/DatePicker/DateTimePicker';
import MultiTextInput from '../../../../components/fields/MultiTextInput/MultiTextInput';

export default function TripForm(props) {
  const { control, formMeta } = props;
  const dto = new VisitDTO();
  const attributes = dto.getAttributesByName();

  return (
    <>
      <Row className="row-cols-1">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.carrier_external_id}
          variant="material"
        />
      </Row>
      <Row className="row-cols-2">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={DateTimePicker}
          onChangeToIso
          withLabel
          dtoObject={attributes.trip_started_at}
          variant="material"
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={DateTimePicker}
          onChangeToIso
          withLabel
          dtoObject={attributes.trip_ended_at}
          variant="material"
        />
      </Row>
      <Row className="row-cols-3">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={MultiTextInput}
          dtoObject={attributes.trip_start_point}
          variant="material"
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={MultiTextInput}
          dtoObject={attributes.trip_end_point}
          variant="material"
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={MultiTextInput}
          dtoObject={attributes.trip_intermediate_points}
          variant="material"
        />
      </Row>
      <Row className="row-cols-1">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.trip_cost}
          variant="material"
        />
      </Row>
      <Row className="row-cols-2">
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.driver_external_id}
          variant="material"
        />
        <FieldDTOWithCol
          control={control}
          formMeta={formMeta}
          type="text"
          component={TextInputWithLabel}
          dtoObject={attributes.vehicle_external_id}
          variant="material"
        />
      </Row>
    </>
  );
}
